export default __webpack_public_path__ + "static/media/pluaris-dashboard.2214b192.png";